import { createAction, createReducer } from 'redux-act';
import Immutable from 'immutable'

const calculate = createAction('Call to API to calculate');


const initialState = Immutable.fromJS({
    screen: 'initial'
})

const questionsReducer = createReducer({

}, initialState)

export default questionsReducer;
export {
    calculate
}